import { property } from "../data/property";
import { MapPin, ExternalLink } from "lucide-react";
import Reveal from "./Reveal";
import SunFlare from "./SunFlare";

export default function Neighborhood() {
  const n = property.neighborhoodInfo;

  return (
    <section
      id="buurt"
      data-testid="neighborhood-section"
      className="relative overflow-hidden bg-brand-surface py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-16">
          {/* Image left */}
          <Reveal className="md:col-span-6 lg:col-span-7">
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1779983645195-b4b877d886cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxkdXRjaCUyMG5laWdoYm9yaG9vZCUyMHN0cmVldCUyMHRyZWVzfGVufDB8fHx8MTc4MDU4NjU4Nnww&ixlib=rb-4.1.0&q=85"
                alt="De Horden Schepen, Wijk bij Duurstede"
                className="h-full w-full object-cover"
                loading="lazy"
              />
              <SunFlare intensity="soft" side="top-right" />
              <div className="absolute bottom-6 left-6 flex items-center gap-2 bg-brand-bg/95 px-4 py-3 text-sm font-medium text-brand-ink backdrop-blur">
                <MapPin size={16} className="text-brand-moss" />
                {n.name} · {n.city}
              </div>
            </div>
          </Reveal>

          {/* Text right */}
          <Reveal className="md:col-span-6 lg:col-span-5" delay={0.15}>
            <p className="overline">De buurt</p>
            <h2 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-brand-ink sm:text-5xl text-balance">
              Wonen aan de rand van een{" "}
              <span className="italic">historisch</span> stadje.
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-brand-muted">
              {n.description}
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6 border-y border-brand-border py-8">
              <div data-testid="neighborhood-residents">
                <p className="overline">Inwoners</p>
                <p className="mt-2 font-serif text-3xl text-brand-ink">{n.residents}</p>
              </div>
              <div data-testid="neighborhood-families">
                <p className="overline">Gezinnen</p>
                <p className="mt-2 font-serif text-3xl text-brand-ink">{n.families}</p>
              </div>
              <div data-testid="neighborhood-price">
                <p className="overline">Gem. m²</p>
                <p className="mt-2 font-serif text-3xl text-brand-ink">{n.avgPrice}</p>
              </div>
            </div>

            <a
              data-testid="neighborhood-map-link"
              href="https://www.google.nl/maps/place/Kempenaar+29+3961KN+Wijk+bij+Duurstede"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 border-b border-brand-moss pb-1 text-sm font-medium text-brand-moss transition-opacity hover:opacity-70"
            >
              Bekijk op Google Maps
              <ExternalLink size={14} />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
